module.exports = __webpack_public_path__ + "img/disavowl--white.d5fddaef.svg";